module.exports = __webpack_public_path__ + "img/visa_logo.ceba54a6.svg";